export enum CookieType {
    CODE_NECCESSARY = 'necessary',
    CODE_PREFERENCE = 'preference',
    CODE_MARKETING = 'marketing',
    CODE_ANALYTICS = 'analytics',
}
